import type { QuestionAnswer } from 'api/ai-builder/requests';

import { AssistantMessage } from './assistant-message';
import { ReasoningMessage } from './reasoning-message';
import { ToolMessage } from './tool-message';
import { UserMessage } from './user-message';

import type { ChatMessage } from '../../hooks';

type MessageItemProps = {
  message: ChatMessage;
  index: number;
  isPrevTool: boolean;
  isNextTool: boolean;
  isDescriptionOpen: boolean;
  onToggleDescription: () => void;
  onSubmitAnswers: (answers: QuestionAnswer[]) => Promise<void>;
  onPickResource: (selection: { id: string; name: string }) => Promise<void>;
  onAcceptPlan: () => Promise<void>;
  onApproveEnterPlanMode: () => Promise<void>;
  onRejectEnterPlanMode: () => Promise<void>;
  isPlanLoading?: boolean;
  isModeLoading?: boolean;
};

export const MessageItem = ({
  message,
  index,
  isPrevTool,
  isNextTool,
  isDescriptionOpen,
  onToggleDescription,
  onSubmitAnswers,
  onPickResource,
  onAcceptPlan,
  onApproveEnterPlanMode,
  onRejectEnterPlanMode,
  isPlanLoading,
  isModeLoading,
}: MessageItemProps) => {
  const { role, id, text } = message;

  return (
    <div data-message-id={id}>
      {role === 'assistant' && message.messageType === 'reasoning' && (
        <ReasoningMessage
          id={id}
          timeTakenSeconds={message.timeTakenSeconds}
          planSummary={message.planSummary}
          isExpanded={isDescriptionOpen}
          onToggle={onToggleDescription}
        />
      )}

      {role === 'assistant' && message.messageType !== 'reasoning' && (
        <AssistantMessage
          text={text}
          errorMessage={message.errorMessage}
          errorType={message.errorType}
        />
      )}

      {role === 'tool' && (
        <ToolMessage
          toolName={message.toolName}
          toolLabel={message.toolLabel}
          toolDescription={message.toolDescription}
          status={message.status}
          data={message.data}
          errorMessage={message.errorMessage}
          isNextTool={isNextTool}
          isDescriptionOpen={isDescriptionOpen}
          onToggleDescription={onToggleDescription}
          onSubmitAnswers={onSubmitAnswers}
          onPickResource={onPickResource}
          onAcceptPlan={onAcceptPlan}
          onApproveEnterPlanMode={onApproveEnterPlanMode}
          onRejectEnterPlanMode={onRejectEnterPlanMode}
          isPlanLoading={isPlanLoading}
          isModeLoading={isModeLoading}
        />
      )}

      {role === 'user' && <UserMessage id={id} text={text} files={message.files} />}
    </div>
  );
};
